<template>
  <div class="radio-button">
    <input
      type="radio"
      :id="randomIdKey"
      :value="value"
      v-model="modelValue"
    >
    <label :for="randomIdKey">{{value}}</label>
  </div>
</template>

<script>
import { getRandomIdKey } from '@/utilities/math.utilities'

export default {
  name: 'RadioButton',
  props: {
    model: {
      type: String,
      required: false
    },
    value: {
      type: String
    }
  },
  data() {
    return {
      randomIdKey: getRandomIdKey()
    }
  },
  computed: {
    modelValue: {
      get: function() {
        return this.model
      },
      set: function() {
        this.$emit('setValue', this.value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/styles/colors';
@import '../../../assets/styles/mixin';

.radio-button {
  margin-top: 5px;
  margin-right: 35px;
  font-size: 13px;
}

input[type=radio] {
  opacity: 0;

  & + label::after {
    content: none;
  }

  &:checked + label::after {
    content: '';
  }

  &:checked + label::before {
    border-color: $gd-blue;
  }
}

label {
  position: relative;
  left: 8px;
  text-transform: capitalize;

  &::before {
    position: absolute;
    top: 0;
    left: -25px;
    content: '';
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 1px solid $gd-black;
    border-radius: 50%;
  }

  &::after {
    position: absolute;
    top: 4px;
    left: -21px;
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: $gd-blue;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form-elements/radio/RadioButton.vue